import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef } from 'react';
import { ButtonGroup } from '..';
import { withThemeNext } from '../../../../layout/theme-next';
import { renderNode } from '../utils';
import { StyledButton, StyledToggleButton } from './SplitButton.styles';
import { SplitButtonProps } from './SplitButton.types';

const SplitButton = forwardRef<HTMLDivElement, SplitButtonProps>(({
  children,
  buttonText,
  buttonProps,
  toggleProps,
  toggleIcon,
  onClick,
  onToggle,
  ...props
}, ref) => {
  return (
    <>
      <ButtonGroup {...props} ref={ref}>
        <StyledButton
          {...buttonProps}
          onClick={onClick}
          className={buttonProps?.className}
        >
          {renderNode(buttonText)}
        </StyledButton>
        <StyledToggleButton
          {...toggleProps}
          onClick={onToggle}
        >
          {toggleIcon ?? <FontAwesomeIcon icon={solid('chevron-down')} />}
        </StyledToggleButton>
      </ButtonGroup>
      {children}
    </>
  );
});

SplitButton.displayName = 'SplitButton';

export default withThemeNext(SplitButton);
